<template>
  <Form>
    <div class="text-center py-5 px-5">
      <h4>Esqueceu sua senha?</h4>
    </div>

    <div class="input-group pb-3">
      <span class="input-group-text"><UserIcon/></span>
      <input v-model="email" placeholder="Seu e-mail" type="email"
             autocomplete="new-password"
             ref="email"
             class="form-control input" aria-describedby="emailHelp"/>
    </div>

    <div class="form-group pb-5">
      <div class="row">
        <div id="sign-up" class="btn-group col-md-12 mt-3">
          <button :disabled="disableButtonSend" @click="send()" class="btn btn-primary">Enviar</button>
        </div>
      </div>

      <div class="row">
        <div id="sign-in" class="btn-group col-md-12 mt-3">
          <button @click="sendLogin()" class="btn btn-link">Voltar</button>
        </div>
      </div>
    </div>

  </Form>
</template>

<script>
  import Form from '@/components/auth/Form'
  import { UserIcon } from 'vue-feather-icons'

  export default {
    components: { Form, UserIcon },
    computed: {
      disableButtonSend() {
        let inputEmail = this.$refs.email
        if (this.email && inputEmail)
          return !inputEmail.checkValidity()
        else
          return true
      }
    },
    data() {
      return {
        email: '',
      }
    },
    methods: {
      send() {
        const params = {
          email: this.email,
          redirect_url: `${location.origin}/reset_password`
        }

        this.axios.post('/auth/password', params)
          .then(response => this.$notify.add(response.message, { closingTime: 15000 }))
          .catch(e => this.$notify.addError(e))
      },
      sendLogin() {
        this.$router.push('login')
      }
    },
    name: 'ForgotPassword'
  }
</script>

<style scoped>

</style>
